export default __webpack_public_path__ + "static/media/gamingPlatform.9849026c.svg";